import * as ax from "axios";

class axios {
  static axiosInstance = null;

  static getInstance() {
    if (!axios.axiosInstance) {
      axios.axiosInstance = ax.create();
    }
    return axios.axiosInstance;
  }
}

export default axios.getInstance();
